import React, { Component, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { classList } from "src/@bootstrap/helpers";
import { checkMenuItemPermission } from '../layout/Layout1/Layout1SidenavEditable';
import DropDownMenuItem from "./DropDownMenuItem";

class DropDownMenu extends Component {
  state = {
    open: false,
  };

  onItemClick = (e) => {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  };

  renderLevels = (items) =>
    items.map((item, i) => {
      if (!checkMenuItemPermission(item, this.props.userPermissions)) return null;

      if (item.sub) {
        return (
          <DropDownMenuItem key={i} item={item}>
            {this.renderLevels(item.sub)}
          </DropDownMenuItem>
        );
      } else {
        return (
          <li
            key={i}
            className={classList({
              "nav-item": true,
              open: this.state.open,
            })}
            onClick={this.props.closeSecSidenav}
          >
            <NavLink activeClassName="selected" className={this.props.location.pathname === item.path ? 'open' : ''} exact to={item.path}>
              <i className={`nav-icon ${item.icon}`}></i>
              <span className="item-name">{item.name}</span>
            </NavLink>
          </li>
        );
      }
    });

  render() {
    return <ul className="childNav">{this.renderLevels(this.props.menu)}</ul>;
  }
}

export default DropDownMenu;
